import { render } from "./en.vue?vue&type=template&id=20cefa98&scoped=true"
import script from "./en.vue?vue&type=script&lang=js"
export * from "./en.vue?vue&type=script&lang=js"

import "./en.vue?vue&type=style&index=0&id=20cefa98&scoped=true&lang=css"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cefa98"]])

export default __exports__